export default {
    day: '2024-11-23',
    content: {
        meta: [
            {
                type: 'bugfix',
                text: '428'
            }
        ],
    }
}
